import { IAttribute, IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Named } from '../base/named';
import { shellStringResources } from '../../Resources/ShellStringResources';

/*
 * Pipeline Policy.
 */
@Metamodel.model({
    name: 'elapsedTimeMetric',
    referable: true
})
export class ElapsedTimeMetric extends Named {
    public static readonly MODEL: IModel;
    public static readonly DURATION: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.ElapsedTimeMetric,
        association: 'DURATION',
        constraint: {
            required: false,
            minimum_timespan: '0.00:10:00'
        }
    })

    public duration?: string;
}
